export const getFirstPageParam = (id?: string | string[]) => {
	if (!id) return null;
	return Array.isArray(id) ? id[0] : id;
};
